
import './App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { ResponsiveBar } from '@nivo/bar'
import moment from 'moment'
import population from './population.json'
// import datatest from './datatest.json'

import _ from 'lodash'

import spinner from './Spin-1s-200px.gif'

const mycolors = {
  gas: '#f6b26b',
  oil: '#741b47',
  coal: '#351c75'
}

const convertData = (apiResult) => {


  const perCountryHash = {}
  apiResult.data.forEach(element => {
    perCountryHash[element.destination_country] ||= {
      destination_country: element.destination_country
    }
    perCountryHash[element.destination_country][element.commodity_group] ||= 0
    perCountryHash[element.destination_country][element.commodity_group] += element.value_eur
    perCountryHash[element.destination_country].total ||= 0
    perCountryHash[element.destination_country].total += element.value_eur
  })

  const res = Object.values(perCountryHash)



  const byPopulation = res.map((e) => {
    const matchingCountry = population.find((p) => p.country === e.destination_country)
    if (!matchingCountry) {
      console.log("Not matching " + e.destination_country)
      return null
    }
    // Marshall Islands buying too much per capita ;)
    if (e.destination_country === 'Marshall Islands') {
      return null
    }
    // Malta as well
    if (e.destination_country === 'Malta') {
      return null
    }

    const millionInhabitants = matchingCountry.population
    e.gas = (e.gas || 0) / millionInhabitants
    e.oil = (e.oil || 0) / millionInhabitants
    e.coal = (e.coal || 0) / millionInhabitants
    e.total = (e.total || 0) / millionInhabitants
    return e
  })


  const sorted = _.sortBy(byPopulation, 'total').reverse().slice(0, 30).reverse()


  console.log(sorted)

  return sorted
}

const MyResponsiveBar = ({ data /* see data tab */ }) => (
  <ResponsiveBar
    data={data}
    keys={[
      'oil',
      'gas',
      'coal',
    ]}
    indexBy="destination_country"
    margin={{ top: 50, right: 130, bottom: 50, left: 150 }}
    padding={0.3}
    layout="horizontal"
    valueScale={{ type: 'linear' }}
    indexScale={{ type: 'band', round: true }}
    colors={({ id, data }) => mycolors[id]}
    axisTop={{
      tickSize: 5,
      tickPadding: 5,
      tickRotation: 0,
      legend: 'EUR',
      legendOffset: -14
    }}
    axisRight={null}
    axisBottom={null}
    labelSkipWidth={12}
    labelSkipHeight={12}
    role="application"
    barAriaLabel={function (e) { return e.id + ": " + e.formattedValue + " in country: " + e.indexValue }}
    enableLabel={false}

    legends={[
      {
        dataFrom: 'keys',
        anchor: 'top-right',
        direction: 'column',
        justify: false,
        translateX: 120,
        translateY: 0,
        itemsSpacing: 2,
        itemWidth: 100,
        itemHeight: 20,
        itemDirection: 'left-to-right',
        itemOpacity: 0.85,
        symbolSize: 20,
        effects: [
          {
            on: 'hover',
            style: {
              itemOpacity: 1
            }
          }
        ]
      }
    ]}

    tooltip={({ id, value, color }) => (
      <div style={{ backgroundColor: 'white' }} dangerouslySetInnerHTML={{ __html: id + ": " + value.toFixed(2) + " EUR" }}>

      </div>
    )}
  />
)



function App() {
  const [data, setData] = useState([]);

  const today = moment().format("YYYY-MM-DD")
  const daysAgo = moment().subtract(70, 'days').format("YYYY-MM-DD")

  useEffect(async () => {

    const result = await axios(
      `https://api.russiaenergytracker.com/v0/counter?date_from=${daysAgo}&aggregate_by=date,destination_country,commodity_group&use_eu=True&date_to=${today}&format=json`,
    );
    // const result = {
    //   data: datatest
    // }

    const barChartData = convertData(result.data)

    setData(barChartData);
  }, []);


  return (

    <div className="App">
      <h1>Europe is Addicted</h1>
      <div style={{ marginLeft: '20%', marginRight: '20%', textAlign: 'center', lineHeight: '1.4em' }}>
        <span style={{ color: 'darkgreen' }}><strong><em>since we all love rankings..</em></strong> here's another one:</span> <br /><br />
        <strong>Money paid to Russia per capita (per each single citizen) over the past 10 weeks</strong> <br />
        <small>({daysAgo} to {today}, data from <a href="https://www.russiafossiltracker.com/">russiafossiltracker.com</a>, population data from <a href="https://raw.githubusercontent.com/samayo/country-json/eba8f375236af33c3c73f634119435c986a9057e/src/country-by-population.json">here</a>)</small>
        <br></br>
        <small>(<strong>use widescreen on mobile device!</strong>)</small>
      </div>

      {data.length !== 0 ? <section style={{ padding: '30px', height: '1000px' }}>{MyResponsiveBar({ data: data })}</section> : <div>Loading ... <br/><img src={spinner}/></div>}

      <br></br>
      <small>contact me on twitter for feedback etc. <a href="https://twitter.com/Peter_Dunn2">twitter.com/PeterDunn_OSINT</a></small>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

    </div>
  );
}

export default App;
